import { jsx } from 'react/jsx-runtime';
import { ResourceGridDivision } from './ResourceGridDivision.js';
import { Flex } from '@fabric-app/ui/components/Flex';

const ResourceGridDivisions = ({ splitResourceGroups, disableItemPreviewContextMenu, canModifyContent, canMultiSelect, layoutId, zoomLevel, resourcesTotalCount, selectedResourceIds, colorLabels, onInfiniteTrigger, resourcePreviewProps, virtualGridOptions, containerWidth, onResourceClick }) => {
  return /* @__PURE__ */ jsx(Flex, {
    direction: "column",
    gap: "sections",
    children: splitResourceGroups.map((splitGroup, index) => {
      const { title, resources: splittedResources, id, groupTotalCount } = splitGroup;
      const key = `${title}-${id}-division`;
      return splittedResources.length ? /* @__PURE__ */ jsx(ResourceGridDivision, {
        // on mobile view we still allow preview per item
        // on desktop, it's invoking the context menu for all items
        disableItemPreviewContextMenu,
        canModifyContent,
        layoutId,
        zoomLevel,
        resourcesTotalCount: groupTotalCount || resourcesTotalCount,
        titleProp: title,
        viewMode: "Grid",
        splitResourceGroup: splitGroup,
        resources: splittedResources,
        previewSelectedFdocs: selectedResourceIds,
        canMultiSelect,
        colorLabels,
        onInfiniteTrigger: index === splitResourceGroups.length - 1 ? onInfiniteTrigger : void 0,
        resourcePreviewProps,
        virtualGridOptions,
        containerWidth,
        onResourceClick
      }, key) : null;
    })
  });
};

export { ResourceGridDivisions };
//# sourceMappingURL=ResourceGridDivisions.js.map
